import {
  Building_Sanction_Circular_2011_12_List,
  BuildingCircularSiteMenuList,
} from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Building_Sanction_Circular_2011_12 = () => (
  <TableStructure
    list={Building_Sanction_Circular_2011_12_List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2011-12"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2011_12;
